package com.partejar.app.feature.contratos.presentation

import androidx.compose.runtime.Composable
import com.partejar.app.feature.contratos.data.ContractPdf
import kotlinx.coroutines.CancellationException

/** Keeps platform file/opening APIs out of the shared contract screens. */
fun interface ContractPdfHandler {
    fun open(pdf: ContractPdf)
}

@Composable
expect fun rememberContractPdfHandler(): ContractPdfHandler

internal fun openContractPdf(handler: ContractPdfHandler, pdf: ContractPdf): String? = try {
    check(pdf.bytes.isNotEmpty())
    handler.open(pdf)
    null
} catch (error: CancellationException) {
    throw error
} catch (_: Throwable) {
    "Não foi possível abrir o PDF do contrato. Tente novamente."
}
